import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';


import People from '../assets/img/sobre/16.png';
import Garantia from '../assets/img/sobre/garantia-10.png';
import Atendimento from '../assets/img/sobre/atendimento.png';
import Atuacao from '../assets/img/sobre/atuacao.png';
import Processos from '../assets/img/sobre/processos-garantia.png';
import Estrategia from '../assets/img/sobre/estrategia-rh.png';
import Secretaria from '../assets/img/sobre/secretaria.png';
import Pintor from '../assets/img/sobre/pintor.png';
import Garcom from '../assets/img/sobre/garcom.png';
import Recepcionista from '../assets/img/sobre/recepcionista.png';
import Estoquista from '../assets/img/sobre/estoquista.png';
import Eletricista from '../assets/img/sobre/eletricista.png';
import Conservacao from '../assets/img/sobre/conservacao.png';
import MulherApontando from '../assets/img/sobre/mulher-apontando.png';

const carouselItems = [
    { img: Secretaria, title: 'carousel.secretary' },
    { img: Pintor, title: 'carousel.painter' },
    { img: Garcom, title: 'carousel.waiter' },
    { img: Recepcionista, title: 'carousel.receptionist' },
    { img: Estoquista, title: 'carousel.stockist' },
    { img: Eletricista, title: 'carousel.electrician' },
    { img: Conservacao, title: 'carousel.conservation' }
];

const Sobre = () => {
    const { t } = useTranslation('about'); 
    const carouselRef = useRef(null);

    useEffect(() => {
        const carousel = carouselRef.current;
        if (!carousel) return;

        let scrollAmount = 0;
        let slideSpeed = 1;
        let isHovering = false;

        const startCarousel = () => {
            if (!isHovering) {
                scrollAmount += slideSpeed;
                if (scrollAmount >= carousel.scrollWidth / 2) {
                    scrollAmount = 0;
                }
                carousel.scrollLeft = scrollAmount;
            }
            requestAnimationFrame(startCarousel);
        };

        // Verificação para garantir que o carousel não é nulo
        if (carousel) {
            const clone = carousel.innerHTML;
            carousel.innerHTML += clone;
        }

        startCarousel();

        carousel.addEventListener("mouseenter", () => (isHovering = true));
        carousel.addEventListener("mouseleave", () => (isHovering = false));

        return () => {
            carousel.removeEventListener("mouseenter", () => (isHovering = true));
            carousel.removeEventListener("mouseleave", () => (isHovering = false));
        };
    }, []);

    return (
        <>
            <h2 className="our-purpose-h2 container">{t('purpose_title')}</h2>
            <section className="our-purpose-section">
                <div className="our-purpose-container container">
                    <p>{t('purpose_text')}</p>
                    <img className="manredtshirt" src={People} alt={t('alt.man_red_tshirt')} />
                </div>
            </section>

            {/* CARROSSEL INFINITO */}
            <section className="carousel-container">
                <div className="carousel-wrapper">
                    <div className="cards-carousel" ref={carouselRef}>
                        {carouselItems.concat(carouselItems).map((item, index) => (
                            <div className="card" key={index}>
                                <img src={item.img} alt={t(item.title)} />
                                <p>{t(item.title)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="who-we-are-section">
                <div className='container'>
                    <h2 className="who-we-are-h2">{t('who_we_are_title')}</h2>

                    <div className="who-we-are-container">
                        <div className="who-we-are-text">
                            <p>{t('who_we_are_text')}</p>
                        </div>
                    </div>

                    <div className='wrapper'>
                        <div className='features'>
                            <div className='item'>
                                <img width={128} src={Garantia} alt="" />
                                <p>{t('features.experience')}</p>
                            </div>
                            <div className='item'>
                                <img width={128} src={Atendimento} alt="" />
                                <p>{t('features.service')}</p>
                            </div>
                            <div className='item'>
                                <img width={128} src={Atuacao} alt="" />
                                <p>{t('features.presence')}</p>
                            </div>
                            <div className='item'>
                                <img width={128} src={Processos} alt="" />
                                <p>{t('features.processes')}</p>
                            </div>
                        </div>
                        <div className="who-we-are-img">
                            <img src={Estrategia} alt={t('alt.man_notebook')} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="waiting-contact-background">
                <div className="waiting-contact-container container">
                    <div className="texts-container">
                        <h3>{t('contact.title')}</h3>
                        <p>{t('contact.description')}</p>
                    </div>
                    <div className="img-container">
                        <img src={MulherApontando} alt={t('alt.woman_pointing')} draggable="false" />
                        <a className="call-to-action-btn" href="/cadastro">{t('contact.button')}</a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Sobre;
